import { OnboardingMarkerEnum } from '../../enums';
import { HintCardConfig } from './hint-overlay.service';

export const HINT_CONFIG: Partial<Record<OnboardingMarkerEnum, HintCardConfig>> = {
  [OnboardingMarkerEnum.AI_SEARCH_INPUT]: {
    titleKey: 'HINTS.SEARCH_INPUT.TITLE',
    textKey: 'HINTS.SEARCH_INPUT.TEXT',
    iconName: 'sparkles',
    iconWidth: 18,
    iconHeight: 16,
    position: 'bottom',
  },
  [OnboardingMarkerEnum.AI_SEARCH_FIND_SIMILAR]: {
    titleKey: 'HINTS.FIND_SIMILAR.TITLE',
    textKey: 'HINTS.FIND_SIMILAR.TEXT',
    iconName: 'icon-link',
    iconWidth: 14,
    iconHeight: 14,
    position: 'bottom',
  },
  [OnboardingMarkerEnum.AI_SEARCH_JOB_DESC]: {
    titleKey: 'HINTS.JOB_DESCRIPTION.TITLE',
    textKey: 'HINTS.JOB_DESCRIPTION.TEXT',
    iconName: 'hint-file-icon',
    iconWidth: 12,
    iconHeight: 15,
    position: 'bottom',
  },
  [OnboardingMarkerEnum.AI_SEARCH_UPDATE_ARROW]: {
    titleKey: 'HINTS.UPDATE_SEARCH.TITLE',
    textKey: 'HINTS.UPDATE_SEARCH.TEXT',
    iconName: 'hint-update-arrow',
    iconWidth: 23,
    iconHeight: 23,
    position: 'bottom',
  },
  [OnboardingMarkerEnum.SEARCH_HISTORY]: {
    titleKey: 'HINTS.HISTORY.TITLE',
    textKey: 'HINTS.HISTORY.TEXT',
    iconName: 'back-in-time',
    iconWidth: 18,
    iconHeight: 18,
    position: 'bottom',
  },
  [OnboardingMarkerEnum.SEARCH_SAVED]: {
    titleKey: 'HINTS.SAVED.TITLE',
    textKey: 'HINTS.SAVED.TEXT',
    iconName: 'saved-searches',
    iconWidth: 18,
    iconHeight: 18,
    position: 'bottom',
  },
  [OnboardingMarkerEnum.AI_SEARCH_TOGGLE]: {
    titleKey: 'HINTS.AI_TOGGLE.TITLE',
    textKey: 'HINTS.AI_TOGGLE.TEXT',
    iconName: 'hint-ai-toggle',
    iconWidth: 24,
    iconHeight: 13,
    position: 'bottom',
  },
  [OnboardingMarkerEnum.SEARCH_FILTERS]: {
    titleKey: 'HINTS.FILTERS.TITLE',
    textKey: 'HINTS.FILTERS.TEXT',
    iconName: 'icon-filter',
    iconWidth: 18,
    iconHeight: 18,
    position: 'bottom',
  },
  [OnboardingMarkerEnum.AI_SEARCH_BUTTON]: {
    titleKey: 'HINTS.SEARCH_BUTTON.TITLE',
    textKey: 'HINTS.SEARCH_BUTTON.TEXT',
    iconName: 'search-icon',
    iconWidth: 18,
    iconHeight: 18,
    position: 'top',
  },
  [OnboardingMarkerEnum.AI_SEARCH_SUGGESTED_FILTERS]: {
    titleKey: 'HINTS.SUGGESTED_FILTERS.TITLE',
    textKey: 'HINTS.SUGGESTED_FILTERS.TEXT',
    iconName: 'sparkles',
    iconWidth: 18,
    iconHeight: 16,
    position: 'bottom',
  },
  [OnboardingMarkerEnum.AI_SEARCH_ACCURACY]: {
    titleKey: 'HINTS.SEARCH_ACCURACY.TITLE',
    textKey: 'HINTS.SEARCH_ACCURACY.TEXT',
    iconName: 'gear-icon',
    iconWidth: 18,
    iconHeight: 18,
    position: 'bottom',
  },
  [OnboardingMarkerEnum.AI_SEARCH_LIKE]: {
    titleKey: 'HINTS.LIKE_BUTTON.TITLE',
    textKey: 'HINTS.LIKE_BUTTON.TEXT',
    iconName: 'hint-like-icon',
    iconWidth: 22,
    iconHeight: 22,
    position: 'bottom',
  },
  [OnboardingMarkerEnum.SEARCH_MATCH_ANY]: {
    titleKey: 'HINTS.MATCH_ANY.TITLE',
    textKey: 'HINTS.MATCH_ANY.TEXT',
    iconName: 'hint-ai-toggle',
    iconWidth: 24,
    iconHeight: 13,
    position: 'bottom',
  },
};
